import Kolas from './Image/Kolas.jpg'
import Maman from './Image/Maman.jpg'
import Nathan from './Image/Nathan.JPG'
import Jason from './Image/Jason.jpg'
import Ino from './Image/Ino.jpg'
const people = [
  {
    name: "Alfonsus Jason Christian",
    role: "Founder / CEO",
    imageUrl: Jason,
  },
  {
    name: "Nathanael Bernike",
    role: "CTO",
    imageUrl: Nathan,
  },
  {
    name: "Inosensius Dwi Atmoko",
    role: "COO",
    imageUrl: Ino,
  },
  {
    name: "Immanuel Gilland",
    role: "CMO",
    imageUrl: Maman,
  },
  {
    name: "Nicholas Putra Pratama",
    role: "CFO",
    imageUrl: Kolas,
  },
];

export default function Team() {
  return (
    <div className=" py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl gap-x-8 gap-y-20 px-6 lg:px-8 xl:grid-cols-3">
        <div className="max-w-2xl">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Meet our leadership
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Our company made by amazing people who studied in Universitas
            Multimedia Nusantara, located in Gading Serpong, Tangerang.
          </p>
        </div>
        <ul className="grid gap-x-8 gap-y-12 sm:grid-cols-2 sm:gap-y-16 xl:col-span-2">
          {people.map((person) => (
            <li key={person.name}>
              <div className="flex items-center gap-x-6">
                <img
                  className="h-16 w-16 rounded-full"
                  src={person.imageUrl}
                  alt=""
                />
                <div>
                  <h3 className="text-base font-semibold leading-7 tracking-tight text-gray-900">
                    {person.name}
                  </h3>
                  <p className="text-sm font-semibold leading-6 text-indigo-600">
                    {person.role}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
